var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "white py-0" },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            {
              staticClass:
                "modal-title white--text d-flex justify-space-between align-center",
              attrs: { cols: "12" }
            },
            [
              _c(
                "h3",
                { staticClass: "d-flex align-center font-weight-regular" },
                [
                  _c("v-icon", { staticClass: "mr-3", attrs: { dark: "" } }, [
                    _vm._v("mdi-filter-variant")
                  ]),
                  _vm._v(" Filtros de actividad reciente ")
                ],
                1
              ),
              _c(
                "v-icon",
                { attrs: { dark: "" }, on: { click: _vm.cancelFilters } },
                [_vm._v("mdi-close")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mb-8" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex align-end justify-end pa-0",
              attrs: { cols: "2" }
            },
            [
              _c("h4", { staticClass: "font-weight-medium" }, [
                _vm._v("Filtros activos:")
              ])
            ]
          ),
          _c(
            "v-col",
            { staticClass: "chip-filter pb-0 pt-5", attrs: { cols: "9" } },
            _vm._l(_vm.filtersSelected, function(filter) {
              return _c(
                "span",
                { key: filter.name },
                [
                  _c(
                    "v-chip",
                    {
                      staticClass: "ma-1",
                      attrs: {
                        close: "",
                        color: filter.color,
                        outlined: "",
                        small: ""
                      },
                      on: {
                        "click:close": function($event) {
                          return _vm.closePill(filter)
                        }
                      }
                    },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticClass: "my-5 white--text",
                          attrs: { left: "", color: filter.color }
                        },
                        [_vm._v(_vm._s(filter.type))]
                      ),
                      _vm._v(" " + _vm._s(filter.name) + " ")
                    ],
                    1
                  )
                ],
                1
              )
            }),
            0
          ),
          _c(
            "v-col",
            { staticClass: "pa-0 pt-5 d-flex align-end justify-start" },
            [
              _c(
                "v-icon",
                {
                  staticClass: "filter-select",
                  on: { click: _vm.emptyFilters }
                },
                [_vm._v("mdi-filter-variant-remove")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { staticClass: "py-0", attrs: { cols: "12" } },
            [
              _c(
                "v-tabs",
                {
                  staticClass: "mt-1",
                  attrs: {
                    vertical: "",
                    color: "black",
                    "slider-size": "5",
                    "mobile-breakpoint": "700"
                  }
                },
                [
                  _c("p", { staticClass: "px-5 mt-2 filter-options" }, [
                    _vm._v("Filtros disponibles")
                  ]),
                  _c("v-divider"),
                  _c("v-tab", { staticClass: "d-none" }),
                  _c(
                    "v-tab",
                    { staticClass: "d-flex justify-start" },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticClass: "mx-2",
                          attrs: { color: "rgb(104,176,61)", size: "30" }
                        },
                        [
                          _c("span", { staticClass: "white--text title" }, [
                            _vm._v("T")
                          ])
                        ]
                      ),
                      _vm._v("Tipo ")
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-tab",
                    { staticClass: "d-flex justify-start" },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticClass: "mx-2",
                          attrs: { color: "rgb(229,47,87)", size: "30" }
                        },
                        [
                          _c("span", { staticClass: "white--text title" }, [
                            _vm._v("F")
                          ])
                        ]
                      ),
                      _vm._v("Fecha ")
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-tab",
                    { staticClass: "d-flex justify-start" },
                    [
                      _c(
                        "v-avatar",
                        {
                          staticClass: "mx-2",
                          attrs: { color: "rgb(51,73,138)", size: "30" }
                        },
                        [
                          _c("span", { staticClass: "white--text title" }, [
                            _vm._v("E")
                          ])
                        ]
                      ),
                      _vm._v("Estado ")
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-container",
                        { staticClass: "px-12" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { staticClass: "d-flex justify-center" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "filter-warning-icon d-flex align-center justify-center"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "100",
                                            color: "rgb(150,150,150)"
                                          }
                                        },
                                        [_vm._v("mdi-filter-plus")]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-center px-12",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "h3",
                                      { staticClass: "headline text-center" },
                                      [_vm._v("Selecciona un filtro")]
                                    ),
                                    _c("br"),
                                    _c(
                                      "p",
                                      { staticClass: "text-center body-2" },
                                      [
                                        _vm._v(
                                          " Selecciona, al menos, uno de los filtros de la paleta de "
                                        ),
                                        _c("strong", [
                                          _vm._v("filtros disponibles")
                                        ]),
                                        _vm._v(
                                          " que se ubica a la izquierda de esta ventana. "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "1" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "10" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.getTicketTypes(),
                                  label:
                                    "Selecciona uno o varios tipos de ticket",
                                  multiple: "",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.typeFilterSelected,
                                  callback: function($$v) {
                                    _vm.typeFilterSelected = $$v
                                  },
                                  expression: "typeFilterSelected"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "1" } })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "d-flex justify-end",
                              attrs: { cols: "12", sm: "6" }
                            },
                            [
                              _c("v-date-picker", {
                                staticClass: "subtitle",
                                attrs: {
                                  locale: "es",
                                  color: "rgb(149,193,84)",
                                  "header-color": "rgb(64,139,56)",
                                  "selected-items-text": "Rango seleccionado",
                                  min: _vm.minDate,
                                  max: new Date().toISOString().substr(0, 10),
                                  range: "",
                                  "full-width": ""
                                },
                                on: { "click:date": _vm.dateChange },
                                model: {
                                  value: _vm.dates,
                                  callback: function($$v) {
                                    _vm.dates = $$v
                                  },
                                  expression: "dates"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "5" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "half" },
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Rango de fechas a filtrar",
                                          "prepend-icon": "mdi-calendar",
                                          "append-icon": "mdi-close-circle",
                                          readonly: ""
                                        },
                                        on: { "click:append": _vm.emptyDate },
                                        model: {
                                          value: _vm.dates,
                                          callback: function($$v) {
                                            _vm.dates = $$v
                                          },
                                          expression: "dates"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                { staticClass: "half" },
                                [
                                  _c(
                                    "v-col",
                                    { staticClass: "full" },
                                    [
                                      _c(
                                        "v-alert",
                                        {
                                          attrs: {
                                            color: "blue-grey",
                                            icon: "mdi-information-outline",
                                            dense: "",
                                            text: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Selecciona dos fechas para crear un rango"
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c("v-col")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", { attrs: { cols: "1" } }),
                          _c(
                            "v-col",
                            { attrs: { cols: "10" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.getTicketStatus(),
                                  label:
                                    "Selecciona uno o varios estados de ticket",
                                  multiple: "",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.statusFilterSelected,
                                  callback: function($$v) {
                                    _vm.statusFilterSelected = $$v
                                  },
                                  expression: "statusFilterSelected"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-col", { attrs: { cols: "1" } })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c("v-col", { staticClass: "pt-0", attrs: { cols: "12" } }, [
            _c(
              "span",
              { staticClass: "d-flex justify-end" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-2",
                    attrs: { color: "green", outlined: "" },
                    on: { click: _vm.closeDialog }
                  },
                  [_vm._v("Cancelar")]
                ),
                _c(
                  "v-btn",
                  {
                    staticClass: "mx-2 white--text",
                    attrs: { color: "green", disabled: !_vm.canFilter },
                    on: { click: _vm.getFilters }
                  },
                  [_vm._v("Filtrar")]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }